import Anchor from './anchor'
import AnchorItem from './anchorItem'

Anchor.Item = AnchorItem

export default Anchor